/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Positioning_Dialog_SubtitleInputs */



/**
* | output |
* | --- |
* | "Position elements on the plan" |
*
* @param {Positioning_Dialog_SubtitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const positioning_dialog_subtitle = /** @type {((inputs?: Positioning_Dialog_SubtitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Positioning_Dialog_SubtitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Position elements on the plan")
	return /** @type {LocalizedString} */ ("Positionnez les éléments sur le plan")
});